import culture from "./culture";
var numeric = /** @class */ (function () {
    function numeric() {
    }
    numeric.parse = function (nrAsString) {
        if (nrAsString === "" || nrAsString === undefined || nrAsString === null) {
            return undefined;
        }
        if (!nrAsString) {
            return undefined;
        }
        if (culture.info.decimalSep && culture.info.decimalSep.length > 1) {
            throw "DecimalSep cannot be more than one character";
        }
        if (culture.info.thousandSep && culture.info.thousandSep.length > 1) {
            throw "ThousandSep cannot be more than one character";
        }
        var str = "";
        var comma_sep = culture.info.decimalSep;
        for (var i = 0; i < nrAsString.length; i++) {
            var c = nrAsString.charAt(i);
            if (c === comma_sep) {
                str += '.';
            }
            else if (c === '0' || c === '1' || c === '2' || c === '3' || c === '4' || c === '5' || c === '6' || c === '7' || c === '8' || c === '9' || (c === '-' && str === "")) {
                str += c;
            }
        }
        return parseFloat(str);
    };
    numeric.format = function (nr, format) {
        if (isNaN(nr) || nr === null || nr === undefined) {
            return "";
        }
        if (culture.info.decimalSep && culture.info.decimalSep.length > 1) {
            throw "DecimalSep cannot be more than one character";
        }
        if (culture.info.thousandSep && culture.info.thousandSep.length > 1) {
            throw "ThousandSep cannot be more than one character";
        }
        var f = format || culture.info.numberFormat;
        var cacheEntry = numeric.formatCache[f];
        if (!cacheEntry) {
            numeric.formatCache[f] = cacheEntry = numeric.parseNrFormat(f);
        }
        return numeric.formatNumber(nr, cacheEntry);
    };
    numeric.parseNrFormat = function (format) {
        var prefix = "";
        var suffix = "";
        var show_sep = format.indexOf(',#') > 0 || format.indexOf(',0') > 0;
        var min_length = 0;
        for (var i = 0; i < format.length; i++) {
            if (format.charAt(i) === '.') {
                break;
            }
            if (format.charAt(i) === '0') {
                min_length++;
            }
            if (min_length === 0 && format.charAt(i) !== ',' && format.charAt(i) !== '0' && format.charAt(i) !== '.' && format.charAt(i) !== '#') {
                prefix += format.charAt(i);
            }
        }
        var max_comma_places = 0;
        var min_comma_places = 0;
        var comma_pos = format.indexOf('.');
        if (comma_pos >= 0) {
            for (var j = comma_pos + 1; j < format.length; j++) {
                if (format.charAt(j) === '0') {
                    min_comma_places++;
                }
                else if (format.charAt(j) === '#') {
                    max_comma_places++;
                }
                else if (format.charAt(j) !== ',' && format.charAt(j) !== '.') {
                    suffix += format.charAt(j);
                }
            }
        }
        max_comma_places += min_comma_places;
        return { max_comma_places: max_comma_places, min_comma_places: min_comma_places, min_length: min_length, prefix: prefix, suffix: suffix, show_sep: show_sep };
    };
    numeric.formatNumber = function (nr, format) {
        //defaults
        var comma_separator = culture.info.decimalSep;
        var thousand_separator = culture.info.thousandSep;
        var cp_min = format.min_comma_places || 0;
        var cp_max = format.max_comma_places || 0;
        var ml = format.min_length || 0;
        //check if number is negative
        var negative = nr < 0;
        if (negative) {
            nr = -nr;
        }
        //convert number to a string and round
        var nr_str_raw = nr.toFixed(cp_max);
        var cp = cp_max;
        //remove comma-places which are not necessary
        var end = nr_str_raw.indexOf('.') + cp_min;
        if (end >= 0) {
            var x = nr_str_raw.length - 1;
            while (x > end) {
                if (nr_str_raw.charAt(x) === '0') {
                    cp--;
                    nr_str_raw = nr_str_raw.slice(0, -1);
                }
                else {
                    break;
                }
                x--;
            }
            if (nr_str_raw.charAt(x) === '.') {
                nr_str_raw = nr_str_raw.slice(0, -1);
            }
        }
        var nr_str = comma_separator !== "." ? nr_str_raw.replace(".", comma_separator) : nr_str_raw;
        var t = cp ? cp + 1 : 0;
        // add "0" at the front if necessary
        while (nr_str.length < ml + t) {
            nr_str = "0" + nr_str;
        }
        // insert thousand-separator if necessary
        t += 3;
        while (nr_str.length > t && format.show_sep) {
            nr_str = nr_str.substr(0, nr_str.length - t) + thousand_separator + nr_str.substr(nr_str.length - t);
            t += 4;
        }
        //remove first 0 if necessary
        if (ml === 0 && nr_str.charAt(0) === '0') {
            nr_str = nr_str.slice(1);
        }
        //return number
        if (negative && parseFloat(nr_str_raw) !== 0) {
            return (format.prefix || "") + "-" + nr_str + (format.suffix || "");
        }
        else {
            return (format.prefix || "") + nr_str + (format.suffix || "");
        }
    };
    numeric.formatCache = {};
    return numeric;
}());
export { numeric };
